import styled from 'styled-components';

import { gql } from '@apollo/client';
import { NextPage } from 'next';
import { ContactForm } from '../components/contact/contactForm';
import { FOOTER_QUERY } from '../components/footer';
import { DarkFooter } from '../components/footer/darkFooter';
import { Header, HEADER_QUERY } from '../components/header';
import { Col, ResponsiveContainer, Row } from '../components/responsive';
import { ContentStackClient } from '../lib/contentstack';
import { Contact } from '../types/contentstack';
import { IPageProps } from '../types/page';
import { mediaScreen } from '../utils/mediaScreen';

export const Page: NextPage<IPageProps<Contact>> = ({
  header,
  page,
  footer,
}) => {
  return (
    <>
      <Header
        pageTitle={page?.title}
        pageDescription={page?.description}
        {...header}
      />

      <ResponsiveContainer>
        <Row>
          <Content md={12}>
            <Title>{page?.hero?.title}</Title>
            <Text>{page?.hero?.text}</Text>

            <ContactForm />
          </Content>
        </Row>
      </ResponsiveContainer>

      <DarkFooter links={footer?.links} />
    </>
  );
};

export async function getServerSideProps() {
  try {
    const { data } = await ContentStackClient().query<IPageProps<Contact>>({
      query: PAGE_QUERY,
    });

    return { props: data };
  } catch (e) {
    return { props: {} };
  }
}

const PAGE_QUERY = gql`
  query contactQuery {
    ${HEADER_QUERY}
    ${FOOTER_QUERY}

    page: contact(uid: "bltb5b24f1ca45dad2f") {
      title
      description
      hero {
        title
        text
      }
    }
  }
`;

const Content = styled(Col)`
  align-items: center;
  display: flex;
  flex-direction: column;

  ${mediaScreen('xs', 'md')} {
    align-items: flex-start;
  }
`;

const Title = styled.h1`
  font-size: 67px;
  color: white;
  font-weight: bold;
  margin-bottom: 0;
  margin-top: 150px;
  text-align: center;

  ${mediaScreen('xs', 'md')} {
    font-size: 35px;
    text-align: left;
    margin-bottom: 24px;
  }
`;

const Text = styled.p`
  color: white;
  font-size: 22px;
  line-height: 32px;
  margin: 0 auto;
  margin-bottom: 64px;
  text-align: center;
  max-width: 630px;

  ${mediaScreen('xs', 'md')} {
    font-size: 17px;
    margin: 0;
    margin-bottom: 64px;
    text-align: left;
  }
`;

export default Page;
